<template>
  <div
    v-if="!!items"
    id="LetsCenterPicker"
    :class="[ { 'letsCenterSelectWrapper': !fullWidth }]"
  >
    <VAutocomplete
      v-bind="$attrs"
      v-model="dselectedCenter"
      :items="items"
      density="compact"
      variant="outlined"
      :placeholder="$attrs.placeholder"
      hide-details="auto"
      :item-title="itemText"
      item-value="value"
    ></VAutocomplete>
    <div v-debug>
      {{
        {
          authorityMode,
          groupMode,
        }
      }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type:[Number, Object,String],
      default: null,
    },
    groupMode:{
      type: Boolean,
      default: false,
    },
    /**
     * Shows the centers list depending on the user's authority.
     */
    authorityMode:{
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    itemText: {
      type: String,
      default: 'label',
    },
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      dselectedCenter: this.modelValue || null,
    };
  },
  computed:{
    ...require('vuex').mapState("Auth", [
      "m0110Center",
      "m0110CenterGroup",
      "m0110Center_Authority",
      "m0110CenterGroup_Authority",
    ]),
    // @public
    items(){
      if (this.authorityMode) {
        if (this.groupMode)
          return this.m0110CenterGroup_Authority;
        else
          return this.m0110Center_Authority;
      } else {
        if (this.groupMode)
          return this.m0110CenterGroup;
        else
          return this.m0110Center;
      }
    },
  },
  watch: {
    modelValue(newValue) {
      this.dselectedCenter = newValue;
    },
    dselectedCenter(newValue, oldValue) {
      this.$emit('update:modelValue', newValue);
      if (newValue !== oldValue) {
        this.$emit('change', newValue, oldValue);
      }
    },
  },
}
</script>
<style>
.letsCenterSelectWrapper {
  max-width: 250px;
}
/* .letsCenterSelectWrapper input {
  max-width: 200px;
} */

#LetsCenterPicker.C30101_viewOnly fieldset{
  /* hide outline border; */
  color: transparent;
}
#LetsCenterPicker.C30101_viewOnly input{
  color:black;
}
#LetsCenterPicker.C30101_viewOnly.C30101_viewOnly_disabled input{
  color:unset;
}
#LetsCenterPicker.C30101_viewOnly .v-input__append-inner {
  opacity: 0;
}
</style>
